import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex justify-center h-screen pb-12 sm:pt-20"
};
const _hoisted_2 = { class: "w-48 mb-8" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('views.retro.index')
};
import { onBeforeMount, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useConstantStore } from '@/pinia_stores/constant';
import { getArchivedRetros } from '@/data/retros';
import Loading from '@/components/Loading.vue';
import MaturityImages from '@/components/MaturityImages.vue';
import Retros from '@/components/Retros.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'Index',
    setup(__props) {
        const archivedRetros = ref(null);
        const router = useRouter();
        const constantStore = useConstantStore();
        const areActivitiesLoaded = ref(false);
        onBeforeMount(async () => {
            try {
                const retros = await getArchivedRetros();
                archivedRetros.value = retros;
            }
            catch {
                router.push({ name: '404' });
            }
        });
        onMounted(async () => {
            await constantStore.loadActivities();
            areActivitiesLoaded.value = true;
        });
        return (_ctx, _cache) => {
            const _component_section_heading = _resolveComponent("section-heading");
            const _component_paragraph = _resolveComponent("paragraph");
            const _component_transition_a11y = _resolveComponent("transition-a11y");
            return (areActivitiesLoaded.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_transition_a11y, null, {
                        default: _withCtx(() => [
                            (archivedRetros.value)
                                ? (_openBlock(), _createBlock(Retros, {
                                    key: 0,
                                    searchable: "",
                                    heading: _ctx.$t('archived_retros'),
                                    retros: archivedRetros.value,
                                    class: "flex-1"
                                }, {
                                    "empty-state": _withCtx(() => [
                                        _createVNode(_component_section_heading, {
                                            heading: _ctx.$t('empty.title')
                                        }, null, 8, ["heading"]),
                                        _createElementVNode("div", _hoisted_2, [
                                            _createVNode(MaturityImages, {
                                                maturity: 4,
                                                class: "w-full h-full"
                                            })
                                        ]),
                                        _createVNode(_component_paragraph, { class: "mb-8" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('empty.body')), 1)
                                            ], undefined, true),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }, 8, ["heading", "retros"]))
                                : (_openBlock(), _createBlock(Loading, {
                                    key: 1,
                                    class: "mt-8",
                                    "loading-text": _ctx.$t('loading_retros')
                                }, null, 8, ["loading-text"]))
                        ], undefined, true),
                        _: 1
                    })
                ]))
                : _createCommentVNode("", true);
        };
    }
});
